import { createApp, h } from 'vue';
import { createInertiaApp, router } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import Icon from '@/js/Components/Icon.vue';
import Toast from 'vue-toastification';
import { createPinia } from 'pinia';
import 'vue-toastification/dist/index.css';
import './echo';
import 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange.js';

const pinia = createPinia();

createInertiaApp({
    //@ts-ignore
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        createApp({ render: () => h(App, props) })
            .component('Icon', Icon)
            .use(plugin)
            .use(pinia)
            .use(Toast, { position: 'top-left', timeout: 2500 })
            .mount(el);
    }
});

// When a notification is clicked and an existing tab is reused, the service
// worker posts a NAVIGATE message so we route to the target url in-app.
if ('serviceWorker' in navigator) {
    navigator.serviceWorker.addEventListener('message', event => {
        if (event.data?.type === 'NAVIGATE' && event.data.url) {
            try {
                const target = new URL(event.data.url, window.location.origin);
                if (target.origin === window.location.origin) {
                    router.visit(target.pathname + target.search + target.hash);
                }
            } catch {
                // Ignore malformed urls
            }
        }
    });
}

// Service worker update check - especially important for Edge
if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistration('/service-worker.js').then(reg => {
        if (reg) {
            // Check for updates every 60 seconds
            setInterval(() => {
                reg.update();
            }, 60000);

            // Also check immediately
            reg.update();
        }
    });
}

declare global {
    interface Date {
        iso8601Week(): number;
    }
}

Date.prototype.iso8601Week = function() {
    // Create a copy of the current date, we don't want to mutate the original
    const date = new Date(this.getTime());

    // Find Thursday of this week starting on Monday
    date.setDate(date.getDate() + 4 - (date.getDay() || 7));
    const thursday = date.getTime();

    // Find January 1st
    date.setMonth(0); // January
    date.setDate(1); // 1st
    const jan1st = date.getTime();

    // Round the number of days to compensate for daylight saving time
    const days = Math.round((thursday - jan1st) / 86400000); // 1 day = 86400000 ms
    return Math.floor(days / 7) + 1;
};
